<template>
 <div id="PrimaryApplicant">
   <button  v-if="sectionButton.name=='SetAsPrimaryApplicant' && sectionButton.visible!==false" type="button" tabindex="0" class="btn btn-onlyBorder px-1 wsn select list-item px-3"
      @click="promptsetPrimaryApplicantSection(sectionButton, 'setPrimary-applicant-modal')"
      @keydown.enter.prevent.stop="promptsetPrimaryApplicantSection(sectionButton, 'setPrimary-applicant-modal')"
      @keydown.space.prevent.stop="promptsetPrimaryApplicantSection(sectionButton, 'setPrimary-applicant-modal')">
     <div class="float-left text-left d-block pl-1">
      {{ sectionButton.label || 'Unknown label' }}
    </div>
  </button>
  <button v-if="sectionButton.name!=='SetAsPrimaryApplicant'" type="button" tabindex="0" class="section-heading-button btn btn-outline-success px-1 wsn select list-item px-3"
      @click="promptAlterSection(section, 'remove-applicant-modal',sectionButton.name)"
      @keydown.enter.prevent.stop="promptAlterSection(section, 'remove-applicant-modal',sectionButton.name)"
      @keydown.space.prevent.stop="promptAlterSection(section, 'remove-applicant-modal',sectionButton.name)">
    <icon :name="iconName" scale="1.1" class="d-block mx-auto float-left"></icon>
    <div class="float-left text-left d-block pl-1">
      {{ sectionButton.label || 'Unknown label' }}
    </div>
  </button>
   <b-tooltip target="PrimaryApplicant" triggers="focus hover" placement="bottom">
    Co-applicant information must be completed to enable switching applicants
    </b-tooltip>
  <div>
   <b-modal ref="setPrimary-applicant-modal" hide-header hide-footer hide-header-close no-enforce-focus>
      <Trapmodal :group="`remove-modal`" :id="`applicant-setPrimary-modal-id`">
        <div class="remove-confirmation-box applicant-remove-modal" id="applicant-setPrimary-modal">
          <div class="remove-modal-message mb-3">
            <div>Switch the primary applicant?</div>
            <p class="subParagraph">This will swap the primary and co-applicant infromation. You can make changes until the quote is bound.</p>
          </div>
          <div class="remove-modal-sep mt-1 mb-1"></div>
          <div class="remove-btn-box">
            <b-button class="mt-3 remove-btn-cancel longer-width-button" block @keydown.enter.prevent.stop="closeModalApplicant(`setPrimary-applicant-modal`)"
            @keydown.space.prevent.stop="closeModalApplicant(`setPrimary-applicant-modal`)"
              @click="closeModalApplicant(`setPrimary-applicant-modal`)">Cancel</b-button>
            <b-button class="mt-3 section-header-button  longer-width-button" block @keydown.enter.prevent.stop="setPrimaryApplicantSection(section, `setPrimary-applicant-modal`)"
            @keydown.space.prevent.stop="setPrimaryApplicantSection(section, `setPrimary-applicant-modal`)" @click="setPrimaryApplicantSection(section, `setPrimary-applicant-modal`)">
              Switch Applicants</b-button>
          </div>
        </div>
      </Trapmodal>
    </b-modal>
    </div>
  <div>
   <b-modal ref="remove-applicant-modal" hide-header hide-footer hide-header-close no-enforce-focus>
      <Trapmodal :group="`remove-modal`" :id="`applicant-remove-modal-id`">
        <div class="remove-confirmation-box applicant-remove-modal" id="applicant-remove-modal">
          <div class="remove-modal-message mb-3">
            <div>Are you sure you want to remove this co-applicant?</div>
          </div>
          <div class="remove-modal-sep mt-1 mb-1"></div>
          <div class="remove-btn-box">
            <b-button class="mt-3 remove-btn-cancel remove-cust-btn" block @keydown.enter.prevent.stop="closeModalApplicant(`remove-applicant-modal`)"
            @keydown.space.prevent.stop="closeModalApplicant(`remove-applicant-modal`)"
              @click="closeModalApplicant(`remove-applicant-modal`)">Cancel</b-button>
            <b-button class="mt-3 remove-btn-confirm remove-cust-btn" block @keydown.enter.prevent.stop="deleteApplicantSection(section, `remove-applicant-modal`)"
            @keydown.space.prevent.stop="deleteApplicantSection(section, `remove-applicant-modal`)" @click="deleteApplicantSection(section, `remove-applicant-modal`)">
              Remove</b-button>
          </div>
        </div>
      </Trapmodal>
    </b-modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
/* global gtag */
import Trapmodal from 'vue-focus-lock';
import axios from '../../../axios-config';
import commonService from '../../../services/common';
import { rulesMixin } from '../../../mixins/rulesMixin';

export default {
  props: ['section', 'sectionButton'],
  inject: ['$validator'],
   data() {
    return {
      coApplicantData:[],
     }
   },
  components: {
    Trapmodal,
  },
  mixins: [
    rulesMixin,
  ],
  computed: {
    pageData: {
      get() {
        return this.$store.state.updatePageData.pageData;
      },
      set(value) {
       // window.console.info('computed set updatePageData', value);
        this.$store.commit('updatePageData', value); // TODO: Set store value
      },
    }, 
    iconName() {
      const apiEndpoint = (this.sectionButton ? this.sectionButton.on_click : '');
     // TODO: Use config values
      return (apiEndpoint.indexOf('/rules/RemoveCoApplicant') === 0 ? 'minus-circle' : 'plus-circle');
    },
  },
  methods: {
    /**
     * close remove property modal claim/applicant
     * @param {*} sectionModal
     */
    closeModalApplicant(sectionModal) {
      this.$refs[sectionModal].hide();
    },
    isRemoveEndpoint(sectionButton) {
      const apiEndpoint = sectionButton.on_click;
     // TODO: Use config values
      return (apiEndpoint.indexOf('/rules/RemoveCoApplicant') === 0);
    },
    alterSection(sectionButton) {
      axios.post(
        sectionButton.on_click, // API endpoint URL
        {
          fields: commonService.getFormData(this.pageData), // All of the current `pageData` fields
          page_name: this.pageData.page_name, // Current `pageData` `page_name`
          session_id: this.$store.getters.getSessionID, // Current Session ID
        },
      ).then((response) => {
        console.log('response.data after adding co-applicant',response.data);
        this.pageData = response.data; // TODO: Use API property names
        this.coApplicantData = this.pageData.fields.filter(fields => fields.section === "(Co-Applicant)" && fields.is_required == true);
        console.log('this.coApplicantData after adding co-applicant',this.coApplicantData);
      }).catch((error) => {
        // TODO: Use response (data or http code) to evaluate error

        window.console.warn('An error occurred while requesting a section button post:', error);
        gtag('event', 'exception', {
          description: 'Error requesting section button quote',
          fatal: false, // set to true if the error is fatal
        });
      });
    },
    promptsetPrimaryApplicantSection(section, applicantModal) {
      this.validateCoApplicantFields(applicantModal);
      const pageData = this.$store.state.updatePageData.pageData;
      const buttons = pageData.section_buttons || [];
     },
   async validateCoApplicantFields(applicantModal){
      let results=[]; 
      this.coApplicantData = this.pageData.fields.filter(fields => fields.section === "(Co-Applicant)" && fields.is_required == true);
      for (const item of  this.coApplicantData) {
      const result = await this.$validator.validate(item.field_name);
      if(result){
         results.push(result);
       }
     } 
     if(results.length===this.coApplicantData.length)
       this.$refs[applicantModal].show();
    },
    setPrimaryApplicantSection(section, applicantModal){
      let session_id= this.$store.getters.getSessionID;
      let getUrl = `/pages/HOOccupants/${session_id}`;
      const pageData = this.$store.state.updatePageData.pageData;
      const buttons = pageData.section_buttons || [];
      const sectionButtons = buttons.filter(button => button.section === section);
      const sectionButton= sectionButtons.filter(sButton => sButton.name =='SetAsPrimaryApplicant')[0];
      axios.post(
        sectionButton.on_click, // API endpoint URL
        {
          fields: commonService.getFormData(this.pageData),
          page_name: this.pageData.page_name, // Current `pageData` `page_name`
          session_id: this.$store.getters.getSessionID, // Current Session ID
        },
      ).then((response) => {
        // Reload the page if the from and to routes are the same so that it gets new page data.
         // if (response.data.Navigate.toLowerCase() === currentNavLink.toLowerCase()) {
          this.$router.go(commonService.getRouteName(getUrl)); // TODO Fetch the page data, don't reload
        //}
      }).catch((error) => {
        // TODO: Use response (data or http code) to evaluate error

        window.console.warn('An error occurred while requesting a section button post:', error);
        gtag('event', 'exception', {
          description: 'Error requesting section button quote',
          fatal: false, // set to true if the error is fatal
        });
     });
     this.$refs[applicantModal].hide();
     },
    deleteApplicantSection(section, applicantModal) {
      const pageData = this.$store.state.updatePageData.pageData;
      const buttons = pageData.section_buttons || [];
      const sectionButtons = buttons.filter(button => button.section === section);
      const sectionButton= sectionButtons.filter(sButton => sButton.name =='CoApplicant')[0];
      this.alterSection(sectionButton);
      this.$refs[applicantModal].hide();
    },
    promptAlterSection(section, applicantModal,sectionButtonname) {
      const pageData = this.$store.state.updatePageData.pageData;
      const buttons = pageData.section_buttons || [];
      const sectionButtons = buttons.filter(button => button.section === section);
      const sectionButton= sectionButtons.filter(sButton => sButton.name ==sectionButtonname)[0];
      if (this.isRemoveEndpoint(sectionButton)) {
      /*  // TODO: Use config values
        const options = {
          okText: 'Remove',
          cancelText: 'Cancel',
          html: true,
          animation: 'zoom',
          backdropClose: true,
        };

        // TODO: Use config values
        this.$dialog
          .confirm('Are you sure you want to remove this co-applicant?', options)
          .then(() => {
            window.console.info('Delete section:', section);
            this.alterSection(sectionButton);
          })
          .catch(() => {
            window.console.info('Did not delete section:', section);
          });
          */
        this.$refs[applicantModal].show();
      } else {
        //window.console.info('Add section:', section);
        this.alterSection(sectionButton);
      }
    },
  },
};
</script>

<style scoped>
.btn-onlyBorder{
 border: 1px solid #ffffff;
 color: #fff;
 background-color: none;
}
.btn-onlyBorder:hover,.btn-onlyBorder:focus{
 border: 1px solid #ffffff;
 background-color: #fff6; 

}
.subParagraph{
  font-size: .75rem;
  line-height: 1.5;
  font-weight: 400;
}
.longer-width-button {
    width: 44%;
    display: inline-block;
    position: relative;
    min-width: 80px;
    padding: 6px 20px;
    border-radius: 4px;
    outline: 0 !important;
    border: 2px solid transparent;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-size: 16px;
    font-weight: 700;
    text-transform: none !important;
    height: 40px;
}
.home .layout-occupants .section-header-button:hover{
 background-color: #fff;
 color: #2E7B32;
 float: right;
}
.home .layout-occupants .section-header-button{
   background-color: #2E7B32;
   color: #fff;
    border-color: #2E7B32;
    float: right;
}


.home .layout-occupants .section-heading-button:hover{
 border-color:#4dbd74 !important;
 color:#4dbd74 !important;
 background-color: #fff !important;
}
.home .layout-occupants .section-heading-button{
  background-color: #2E7B32 !important;
  border-color: #2E7B32 !important;
  color: #fff !important;
}
.section-heading-button {
  background-color: #fff;
  color: #3674B2;
  border-color: #3674B2;
  margin-right: 0.7rem;
}
.section-heading-button:hover, .section-heading-button:not(:disabled):not(.disabled):active {
  background-color: #3674B2;
  color: #fff;
  border-color: #fff;
}
.renters .layout-occupants .section-heading-button:hover{
  border-color:#2E7B32 !important;
  color:#fff !important;
  background-color: #2E7B32 !important;
}
.renters .layout-occupants .section-heading-button{
  background-color: #fff !important;
  border-color: #2E7B32 !important;
  color: #2E7B32 !important;
}
.condo .layout-occupants .section-heading-button:hover{
  border-color:#2E7B32 !important;
  color:#fff !important;
  background-color: #2E7B32 !important;
}
.condo .layout-occupants .section-heading-button{
  background-color: #fff !important;
  border-color: #2E7B32 !important;
  color: #2E7B32 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/SectionHeadingButton.vue?8dddf832